import { QualifyingLifeEventType } from '@zorro/clients';
import { Alert } from '@zorro/design-system/v2/Alert';
import { Stack, Text } from '@zorro/web/design-system';

import {
  getCoverageBannerText,
  getCoverageBannerVariant,
} from './qleCoverageBanner.utils';

interface QleCoverageBannerProps {
  qleType: QualifyingLifeEventType;
  eventDate: Date;
}

export const QleCoverageBanner = ({
  qleType,
  eventDate,
}: QleCoverageBannerProps) => {
  const variant = getCoverageBannerVariant(qleType, eventDate);

  if (!variant) {
    return null;
  }

  return (
    <Alert variant="general-note">
      <Stack gap="sm" mr="xxs">
        <Text size="sm">{getCoverageBannerText(variant, true)}</Text>
        <Text size="sm">
          <Text span fw={600} size="sm">
            Remember:
          </Text>{' '}
          Opening this QLE doesn&apos;t enroll the employee — remind them to
          submit their plan election by the cutoff date to secure their
          coverage.
        </Text>
      </Stack>
    </Alert>
  );
};
